import { useQuery } from '@tanstack/react-query';
import { StateClient, StateDTO } from '../services/apiClient';
import { API_BASE_URL, MAX_DROPDOWN_PAGE_SIZE } from '../config/config';
import axiosInstance from '../services/axiosInstance';

const apiClient = new StateClient(API_BASE_URL, axiosInstance);

// Query hook - Get all states for dropdowns (cached 4 hours)
export const useStates = () => {
  return useQuery({
    queryKey: ['states'],
    queryFn: async () => {
      const response = await apiClient.searchStates({
        page: 1,
        pageSize: MAX_DROPDOWN_PAGE_SIZE,
        sortBy: 'Name',
      });
      // NSwag generates one shared ApiResponse_searchResponseDTO_1 type (typed against
      // CountryDTO) for nearly every search* method — a codegen collision affecting most
      // entities, not just this one. The runtime data is genuinely StateDTO[]; only the
      // generated type is wrong.
      return (response?.data?.results as StateDTO[] | undefined) || [];
    },
    staleTime: 4 * 60 * 60 * 1000, // 4 hours
    refetchOnReconnect: true,
  });
};
